import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { router } from './router';
import { AppContextProvider } from './utils/context';

import { initializeSentry } from './initialize/initializeSentry';
import { initializeReactQuery } from './initialize/initializeReactQuery';

import 'leaflet/dist/leaflet.css';
import 'tippy.js/dist/tippy.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.scss';

const { queryClient } = initializeReactQuery();
initializeSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <AppContextProvider>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </AppContextProvider>,
);

// Strict mode causes stuff to render twice and some endpoints get called twice,
// so we don't use it:
//
// <React.StrictMode>
//   ...
// </React.StrictMode>,
